import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { NfcRestrictedModalComponent } from '../../shared/components/nfc-restricted-modal/nfc-restricted-modal.component';

/**
 * Roles que tienen acceso completo solo si inician sesión con tarjeta NFC.
 * Si inician con usuario/contraseña, solo pueden ver el Dashboard y
 * Atención - Órdenes → Resultados (/sys/clinical/resultado).
 */
const RESTRICTED_ROLES = ['ENCARGADO', 'RADIOLOGO'];

const ALLOWED_PATHS = ['/sys/dashboard', '/sys/clinical/resultado'];

/**
 * Guard que restringe el acceso de ENCARGADO/RADIOLOGO sin sesión NFC.
 * Al intentar acceder a una vista no permitida cancela la navegación
 * (el usuario se queda en la vista actual) y muestra un modal con las
 * opciones "Cerrar" o "Ir al Dashboard".
 */
export const nfcRestrictedGuard: CanActivateFn = (route, state): boolean => {
    const dialogService = inject(DialogService);

    const userStr = localStorage.getItem('user_info');
    if (!userStr) return true;

    let user;
    try {
        user = JSON.parse(userStr);
    } catch {
        return true;
    }

    const roles: string[] = Array.isArray(user?.roles) ? user.roles : [];
    const isRestrictedRole = roles.some((r) => RESTRICTED_ROLES.includes(r));
    if (!isRestrictedRole) return true;

    // Si inició sesión con tarjeta NFC tiene acceso completo
    const loginMethod = localStorage.getItem('login_method');
    if (loginMethod === 'nfc') return true;

    const url = state.url.split('?')[0];
    if (ALLOWED_PATHS.some((p) => url.startsWith(p))) return true;

    console.warn('⛔ Acceso restringido sin NFC:', state.url);

    dialogService.open(NfcRestrictedModalComponent, {
        header: 'Acceso restringido',
        width: '420px',
        closable: false,
        modal: true,
        dismissableMask: false,
        baseZIndex: 10000
    });

    return false;
};
